<template>
  <div>
    <base-button
      type="primary"
      class="uppercase flex w-full md:w-auto md:mt-0 mt-4 font-normal text-sm"
      @click="createPost"
      ><feather-icon
        icon="PlusIcon"
        class="mr-2"
        svgClasses="w-4 h-4"
      ></feather-icon
      >Create Post</base-button
    >
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    createPost() {
      // console.log("Hello")
      this.$store.commit(
        "UI/TOGGLE_POST_CREATE_SIDEBAR",
        !this.PostCreateSidebar
      );
    },
    computed: {
      ...mapState("auth", ["user"]),
      ...mapState("posts", ["getUSerchannelfeed"]),
      ...mapState("UI", ["PostCreateSidebar"]),
    },
  },
};
</script>

<style>
.cust-pb > .progress-bar {
  background-color: #cbedf2 !important;
}
</style>
